module.exports = __webpack_public_path__ + "img/KIDIWI-digital-white.2d2f01d0.svg";